/**
 * Target garaaz-web (app) origin.
 * Override with GATSBY_WEB_APP_URL when hosts differ.
 */
const UAT_API_HOST = "uat.api.garaaz.com";

export function getWebAppOrigin() {
  if (process.env.GATSBY_WEB_APP_URL) {
    return process.env.GATSBY_WEB_APP_URL.replace(/\/$/, "");
  }

  const apiBase =
    process.env.GATSBY_API_BASE_URL || "https://api.garaaz.com/api";

  if (apiBase.includes(UAT_API_HOST)) {
    return "https://uat.garaaz.com";
  }

  return "https://app.garaaz.com";
}

export function getWebAppPath(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${getWebAppOrigin()}${normalized}`;
}
